import ClickOutside from "./directives/ClickOutside";
import Focus from "./directives/Focus";
import Sticky from "./directives/Sticky";
import { App } from "vue";
export default function (app: App) {
  ClickOutside(app);
  Focus(app);
  Sticky(app);
}
